import angular from 'angular';

import { AddressServiceModule } from '../../address';
import { ModalServiceModule } from '../../modal/modal.service';

/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.membership.cardholder`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/membership/cardholder/membership-cardholder.service.ts
 * Registered via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any `$inject = ['MembershipCardholderService']` resolves to the Angular 18
 * class. Wave 3 item #28.
 */
export { MembershipCardholderService } from '@ng/core/membership/cardholder/membership-cardholder.service';

export const MembershipCardholderServiceModule = angular.module('acme.common.service.membership.cardholder', [
  ModalServiceModule,
  AddressServiceModule,
]).name;
